function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
// import { IndeterminateCheckbox } from '../components';

export function useSelectColumn(hooks, ...rest) {
  hooks.allColumns.push((columns, {
    instance
  }) => {
    const {
      selectColumnPosition = 0,
      SelectComponent
    } = instance;
    let newColumns = [...columns];
    newColumns.splice(selectColumnPosition, 0, {
      id: 'selection',
      // The header can use the table's getToggleAllRowsSelectedProps method
      // to render a checkbox.  Pagination is a problem since this will select all
      // rows even though not all rows are on the current page.  The solution should
      // be server side pagination.  For one, the clients should not download all
      // rows in most cases.  The client should only download data for the current page.
      // In that case, getToggleAllRowsSelectedProps works fine.
      Header: ({
        getToggleAllRowsSelectedProps
      }) => /*#__PURE__*/React.createElement(SelectComponent, _extends({}, getToggleAllRowsSelectedProps(), {
        className: "selection-header"
      })),
      // The cell can use the individual row's getToggleRowSelectedProps method
      // to the render a checkbox
      Cell: ({
        row
      }) => /*#__PURE__*/React.createElement(SelectComponent, _extends({}, row.getToggleRowSelectedProps(), {
        className: "selection-cell"
      })),
      disableResizing: true,
      disableSortBy: true,
      collapsed: true,
      disableOrdering: true,
      minWidth: 30,
      maxWidth: 30,
      width: 30
    });
    return [...newColumns];
  });
}
useSelectColumn.pluginName = 'useSelectColumn';